import moment from 'moment';

export const RECONCILIATION_WEEK_COLOR = '#494968';

export const toPeriodKey = (isoWeekYear, isoWeek) => {
    return `${isoWeekYear}-W${String(isoWeek).padStart(2, '0')}`;
};

export const parsePeriodKey = (periodKey) => {
    const match = periodKey?.match(/^(\d{4})-W(\d{2})$/);
    if (!match) {
        return null;
    }

    const isoWeekYear = Number(match[1]);
    const weekNum = Number(match[2]);
    const weekStart = moment().isoWeekYear(isoWeekYear).isoWeek(weekNum).startOf('isoWeek');
    const weekEnd = weekStart.clone().endOf('isoWeek');

    return {
        isoWeekYear,
        weekNum,
        periodKey,
        from: weekStart.format('YYYY-MM-DD'),
        to: weekEnd.format('YYYY-MM-DD'),
    };
};

export const getWeeksInYear = (isoWeekYear) => {
    const weeksCount = moment().isoWeekYear(isoWeekYear).isoWeeksInYear();
    return Array.from({ length: weeksCount }, (_, index) => {
        const weekNum = index + 1;
        const periodKey = toPeriodKey(isoWeekYear, weekNum);
        return parsePeriodKey(periodKey);
    });
};

export const getCurrentReconciliationWeek = () => {
    const currentWeek = moment();
    return {
        periodKey: toPeriodKey(currentWeek.isoWeekYear(), currentWeek.isoWeek()),
    };
};

export const resolveReconciliationPeriodKey = (row) => {
    if (row?.periodKey) {
        return row.periodKey;
    }
    if (/^\d{4}-W\d{2}$/.test(row?.month)) {
        return row.month;
    }
    return null;
};

export const formatReconciliationWeekLabel = (periodKeyOrMonth, to) => {
    if (/^\d{4}-W\d{2}$/.test(periodKeyOrMonth)) {
        const week = parsePeriodKey(periodKeyOrMonth);
        if (!week) {
            return periodKeyOrMonth;
        }
        return `tuần ${String(week.weekNum).padStart(2, '0')}/${week.isoWeekYear} (${moment(week.from).format('DD/MM')} - ${moment(week.to).format('DD/MM')})`;
    }

    if (!periodKeyOrMonth) {
        return '';
    }

    if (/^\d{4}-\d{2}$/.test(periodKeyOrMonth)) {
        return moment(periodKeyOrMonth, 'YYYY-MM').format('MM/YYYY');
    }

    const weekEnd = to || moment(periodKeyOrMonth).add(6, 'days').format('YYYY-MM-DD');
    return `${moment(periodKeyOrMonth).format('DD/MM')} - ${moment(weekEnd).format('DD/MM')}`;
};

export const formatReconciliationWeekShort = (periodKey) => {
    if (/^\d{4}-W\d{2}$/.test(periodKey)) {
        return periodKey;
    }
    if (!periodKey) {
        return '';
    }
    if (/^\d{4}-\d{2}$/.test(periodKey)) {
        return moment(periodKey, 'YYYY-MM').format('MM/YYYY');
    }
    const week = parsePeriodKey(periodKey);
    if (week) {
        return week.periodKey;
    }
    return periodKey;
};

export const getMonthFromPeriodKey = (periodKey) => {
    const week = parsePeriodKey(periodKey);
    return week?.from ? moment(week.from).format('YYYY-MM') : '';
};
